import actionTypes from '../constants/action-types';

const startB2CDomainPurchase = (triggerId, domainName) => ({
  type: actionTypes.START_B2C_DOMAIN_PURCHASE,
  payload: { triggerId, domainName },
});

export default startB2CDomainPurchase;
